import { WebGLRenderer } from 'three'

import {
  EffectComposer,
  RenderPass,
  EffectPass,
  BokehEffect,
  SSAOEffect,
  BloomEffect,
  SMAAEffect,
  SMAAPreset,
  NormalPass,
  BlendFunction,
  KernelSize
} from 'postprocessing'

export class Renderer {
  constructor (scene, camera) {
    this.scene = scene
    this.camera = camera

    this.resize = this.resize.bind(this)
    this.render = this.render.bind(this)

    this.webGLRenderer = new WebGLRenderer({
      antialias: false,
      alpha: true
    })
    this.webGLRenderer.setClearColor(0xffffff, 0)

    this.bloomEffect = new BloomEffect({
      luminanceThreshold: .9,
      luminanceSmoothing: .4,
      intensity: 2,
      kernelSize: KernelSize.HUGE
    })

    this.smaaEffect = new SMAAEffect(
      Object.assign(new Image(), { src: SMAAEffect.searchImageDataURL }),
      Object.assign(new Image(), { src: SMAAEffect.areaImageDataURL }),
      SMAAPreset.ULTRA
    )

    this.renderPass = new RenderPass(scene, camera)
    this.renderPass.renderToScreen = false

    this.effectPass = new EffectPass(camera,
      this.bloomEffect
      // this.smaaEffect
    )
    this.effectPass.renderToScreen = true

    this.composer = new EffectComposer(this.webGLRenderer)
    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.effectPass)

    this.resize()
  }

  get canvas () {
    return this.webGLRenderer.domElement
  }

  resize () {
    const width = window.innerWidth
    const height = window.innerHeight

    this.webGLRenderer.setSize(width, height)
    this.composer.setSize(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }

  render () {
    // console.log(this.composer)
    this.composer.render()
    // this.webGLRenderer.render( this.scene, this.camera )
  }
}
